import { useRef } from "react";
import PropTypes from "prop-types";
import webContextProvider from "../../../../providers/webContextProvider";
import openSitechromeModal from "../openSitechromeModal";
import getSitechromeModalUrl from "../getSitechromeModalUrl";
import InformationIcon from "../InformationIcon";
import getFulfilmentIds from "../../../../getFulfilmentIds";
import getFulfilmentType, {
  FULFILMENT_TYPE
} from "../../../../getFulfilmentType";
import content from "app-content";

const { AFS } = FULFILMENT_TYPE;

const FulfilmentInformationIcon = ({
  source,
  seller,
  productId,
  variantId,
  showFulfilmentInfo,
  children
}) => {
  const ref = useRef(null);

  const handleClick = e => {
    e.preventDefault();

    const { sourceId, sellerId } = getFulfilmentIds({ source, seller });
    const baseUrl = "/web/pages/seller-info/index.html";
    const { browseLanguage: lang, browseCountry: countryCode } =
      webContextProvider();
    const modalUrl = getSitechromeModalUrl({
      baseUrl,
      additionalParams: { countryCode, lang, sellerId, sourceId }
    });

    openSitechromeModal({
      url: modalUrl,
      focusOnCloseElement: ref.current,
      iFrameTitle: content.seller_info_iframe_title
    });

    const fulfilmentType = getFulfilmentType({ sourceId, sellerId });

    if (fulfilmentType === AFS) {
      showFulfilmentInfo({ productId, variantId, source, seller });
    }
  };

  return (
    <InformationIcon
      ref={ref}
      onClick={handleClick}
      ariaLabel={content.seller_info_more_information}
    >
      {children}
    </InformationIcon>
  );
};

export default FulfilmentInformationIcon;

FulfilmentInformationIcon.propTypes = {
  seller: PropTypes.shape({
    id: PropTypes.string.isRequired
  }).isRequired,
  source: PropTypes.shape({
    id: PropTypes.string.isRequired
  }),
  productId: PropTypes.number.isRequired,
  variantId: PropTypes.number,
  showFulfilmentInfo: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
};
